/// <reference path="../../typings/browser.d.ts" /> 
/// <reference path="../../customtypings/window.d.ts" /> 
 
/** 
 * Network layer service 
 */ 
 
namespace Application.Services { 
    'use strict'; 
 
    import SimPlan = Models.SimPlan; 
    import IHalList = Models.IHalList; 
    import HalConverter = Models.HalConverter; 
    import IHalElement = Models.IHalElement; 
 
    /** 
     * NetworkNodeService 
     */ 
    export class SimPlanService { 
        public static $name: string = "simPlanService"; 
        public static $inject: string[] = ['backendService', 
                                           ]; 
 
        private backendService: BackendService; 
        private backendBaseUrl: string = window.backendUrl; 
        // private servicePath: string = 'networknodes/'; 
        private servicePath: string = ''; 
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'simPlans'; 
         
        constructor(backendService: BackendService) { 
            this.backendService = backendService; 
        } 
 
        public getAllPaginatedSimPlans(callback: (messages: Models.IPaginatedList<Models.SimPlan>) => void, 
                                       page?: number, size?: number, sort?: String): void { 
            let url: string = this.backendUrl + '?'; 
            url = page ? url += '&page=' + page : url; 
            url = size ? url += '&size=' + size : url; 
            url = sort ? url += '&sort=' + sort : url; 
            this.backendService
                .get(url, true)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<SimPlan>>) => { 
                    let convertedList: Models.IPaginatedList<SimPlan>; 
                    convertedList = HalConverter.convertPaginatedList(result.data, SimPlan.Empty); 
                    callback(convertedList);  
                }); 
             
        }
 
        public saveSimPlan(simPlan: SimPlan): ng.IPromise<SimPlan> { 
            if (!simPlan.href || simPlan.href === undefined || simPlan.href === '') { 
                return this.createSimPlan(simPlan); 
            } else { 
                return this.updateSimPlan(simPlan); 
            } 
        } 
 
        public deleteSimPlan(simPlan: SimPlan): ng.IPromise<boolean> { 
            return this.backendService.delete(simPlan.href); 
        }
 
        public getAllSimPlans(callback: (messages: SimPlan[]) => void): void {
            this.getAllSimPlansPromise()
                .then((data: SimPlan[]) => {
                    callback(data);
                });
        }

        public getAllSimPlansPromise(): ng.IPromise<SimPlan[]> {
            let url: string = this.backendUrl + '?page=0&size=9999999';
            return this.backendService
                .get(url)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<SimPlan>>) => {
                    let halElement: IHalList<SimPlan> = result.data;
                    let converted: SimPlan[] = HalConverter.convertList(halElement, SimPlan.Empty);
                    return converted;
                });
        }

        public findByHref(href: string, callback: (result: Models.ISimPlan) => void): void {
            this.getSimPlanPromise(href)
                .then((element: SimPlan) => {
                    callback(element);
                }
            );
        }

        public findByHrefPromise(href: string, callback: (result: Models.ISimPlan) => void): ng.IPromise<SimPlan> {
            return this.getSimPlanPromise(href);
        }

        public getSimPlanPromise(href: string): ng.IPromise<SimPlan> {
            return this.backendService
                .get(href)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<SimPlan>>) => {
                    let halElement: IHalElement<SimPlan> = data.data;
                    let converted: SimPlan = HalConverter.convertElement(halElement, SimPlan.Empty);
                    return converted;
                });
        }

        private createSimPlan(simPlan: SimPlan): ng.IPromise<SimPlan> { 
            return this.backendService 
                .post(this.backendUrl, { 
                    name: simPlan.name, 
                    operatorName: simPlan.operatorName, 
                    operatorCountry: simPlan.operatorCountry, 
                    type: simPlan.type, 
                    dataAmount: simPlan.dataAmount, 
                }) 
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<SimPlan>>) => { 
                    let halElement: IHalElement<SimPlan> = result.data; 
                    let converted: SimPlan = HalConverter.convertElement(halElement, Models.SimPlan.Empty); 
                    return converted; 
                }); 
        } 
 
        private updateSimPlan(simPlan: SimPlan): ng.IPromise<SimPlan> { 
            return this.backendService 
                .put(simPlan.href, { 
                    name: simPlan.name, 
                    operatorName: simPlan.operatorName, 
                    operatorCountry: simPlan.operatorCountry, 
                    type: simPlan.type, 
                    dataAmount: simPlan.dataAmount, 
                }) 
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<SimPlan>>) => { 
                    let halElement: IHalElement<SimPlan> = result.data; 
                    let converted: SimPlan = HalConverter.convertElement(halElement, Models.SimPlan.Empty); 
                    return converted; 
                }); 
        }
    }
}